import { render, staticRenderFns } from "./blog-auto-reply-small-business.vue?vue&type=template&id=03aa6b2f&scoped=true"
import script from "./blog-auto-reply-small-business.vue?vue&type=script&lang=js"
export * from "./blog-auto-reply-small-business.vue?vue&type=script&lang=js"
import style0 from "./blog-auto-reply-small-business.vue?vue&type=style&index=0&id=03aa6b2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03aa6b2f",
  null
  
)

export default component.exports